import { TripBookingTypes } from '../../lib/types/models/trip-booking/trip-booking'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function duplicateTripBooking(id: number) {
  return restApiClient
    .url(constructApiUrl(API['trip-bookings'].duplicate.url, { id }))
    .post<TripBookingTypes.IdOnly>()
}
